import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import useBodyScrollLock from '../hooks/useBodyScrollLock';
import '../styles/product-photo.css';

const ProductImageLightbox = ({ src, alt, onClose }) => {
  useBodyScrollLock();
  const closeButtonRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    closeButtonRef.current.focus({ preventScroll: true });

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        onClose();
      } else if (event.key === 'Tab') {
        event.preventDefault();
        closeButtonRef.current.focus({ preventScroll: true });
      }
    };
    // Capture Escape before the underlying basket handles it.
    document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, [onClose]);

  return createPortal(<div className='product-image-lightbox' role='dialog' aria-modal='true'
    aria-label={`Фото товару: ${alt}`} onClick={event => {
      event.stopPropagation();
      if (event.target === event.currentTarget) onClose();
    }}>
    <button ref={closeButtonRef} type='button' className='product-image-lightbox-close'
      aria-label='Закрити фото' onClick={onClose}>
      <span aria-hidden='true'>×</span>
    </button>
    <img className='product-image-lightbox-photo' src={src} alt={alt} />
  </div>, document.body);
};

export default ProductImageLightbox;
